module.exports = __webpack_public_path__ + "static/media/space-shuttle.2d7a492a.svg";